<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :ajax-params="ajaxParams"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            :showHeader="showTableHeader"
            :pagination="paginateTable"
            ajax-path="phpipam/vlans"     
        />
    </div>
</template>

<script>
    import http from '@/helpers/Http';
    export default {
        props: {
            showTableHeader: {
                type: Boolean,
                default: true,
            },
            paginateTable: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                tableIsLoading: false,
                refreshTable: false,
                ajaxParams:{},
                columns: [
                    {
                        title: 'Name',
                        field: 'name',
                        sorter: 'string',
                        minWidth: 250,
                    },
                    {
                        title: 'Description',
                        field: 'description',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        },
                    },
                    {
                        title: 'L2 Domain',
                        field: 'l2_domain.name',
                        minWidth: 150,
                    },
                ],
                actions: [
                    // {
                    //     label: 'Sync',
                    //     icon: () => import('@/icons/Sync.vue'),
                    //     handler: this.sync
                    // }
                ],
            }
        },
    }
</script>